import { render, staticRenderFns } from "./blog-gbwhatsapp-vs-official-whatsapp.vue?vue&type=template&id=50c7d9d6&scoped=true"
import script from "./blog-gbwhatsapp-vs-official-whatsapp.vue?vue&type=script&lang=js"
export * from "./blog-gbwhatsapp-vs-official-whatsapp.vue?vue&type=script&lang=js"
import style0 from "./blog-gbwhatsapp-vs-official-whatsapp.vue?vue&type=style&index=0&id=50c7d9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c7d9d6",
  null
  
)

export default component.exports